import jmoment from 'jalali-moment'

export function toFaNum(number, toLocalString = true) {
    number = parseInt(number)
    number = toLocalString ? number.toLocaleString() : ((number && number.toString()) || '')
    let id = ['۰', '۱', '۲', '۳', '۴', '۵', '۶', '۷', '۸', '۹'];
    return number.replace(/[0-9]/g, function (w) {
        return id[+w]
    });
}

export function getGatewayName(gateway) {
    if (gateway === 'behpardakht') {
        return 'ملت'
    }
    if (gateway === 'zarinpal') {
        return 'زرین پال'
    }
}

export function nl2br(str, replaceMode, isXhtml) {
    const breakTag = (isXhtml) ? '<br />' : '<br>';
    const replaceStr = (replaceMode) ? '$1' + breakTag : '$1' + breakTag + '$2';
    return (str + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, replaceStr);
}

export function moment(date) {
    let id = ['۰', '۱', '۲', '۳', '۴', '۵', '۶', '۷', '۸', '۹'];
    return jmoment(date).locale('fa').format('jDD jMMMM jYYYY HH:mm').replace(/[0-9]/g, function (w) {
        return id[+w]
    });
}

export function gaState(state, quantity = 1) {
    let categories = {};
    state.product.categories.forEach((cat, i) => {
        const key = i === 0 ? 'item_category' : 'item_category' + (i+1)
        categories[key] = cat.title
    })

    return {
        item_id: state.product.id,
        item_name: state.product.title,
        ...categories,
        item_variant: state.title,
        price: state.price,
        quantity,
    }
}

export function gaProduct(product) {
    let categories = {};
    product.categories.forEach((cat, i) => {
        const key = i === 0 ? 'item_category' : 'item_category' + (i+1)
        categories[key] = cat.title
    })
    return {
        item_id: product.id,
        item_name: product.title,
        ...categories,
        price: product.states ? Math.min.apply(Math, product.states.map((state) => state.price)) : 0,
    }
}
